import { Col } from 'antd';
import React from 'react';
import ZenVerBarChart from '../../components/ManagerDashboard/Common/Graph/ZenVerBarChart';
import ZenHorBarChart from '../../components/ManagerDashboard/Common/Graph/ZenHorBarChart';
import ZenPieBar from '../../components/ManagerDashboard/Common/Graph/ZenPieBar';
import ZenDonut from '../../components/ManagerDashboard/Common/Graph/ZenDonut';
import ZenPareto from '../../components/ManagerDashboard/Common/Graph/ZenPareto';
import ZenWaterfallChart from '../../components/ManagerDashboard/Common/Graph/ZenWaterfallChart';
import ZenRadar from '../../components/ManagerDashboard/Common/Graph/ZenRadar';
import ZenHorStackBar from '../../components/ManagerDashboard/Common/Graph/ZenHorStackBar';
import ZenSpectrum from '../../components/ManagerDashboard/Common/Graph/ZenSpectrum';
import ZenGauge from '../../components/ManagerDashboard/Common/Graph/ZenGauge';
import ZenGaugeMultiColor from '../../components/ManagerDashboard/Common/Graph/ZenGaugeMultiColor';
import ZenGanttChart from '../../components/ManagerDashboard/Common/Graph/ZenGanttChart';
import ZenClusterColHor from '../../components/ManagerDashboard/Common/Graph/ZenClusterColHor';
import ZenClusterColVer from '../../components/ManagerDashboard/Common/Graph/ZenClusterColVer';
import ZenGoldenTunnel from '../../components/ManagerDashboard/Common/Graph/ZenGoldenTunnel';
import ZenHorCandleStick from '../../components/ManagerDashboard/Common/Graph/ZenHorCandleStick';
import ZenStackedNePo from '../../components/ManagerDashboard/Common/Graph/ZenStackedNePo';
import ZenVerBIB from '../../components/ManagerDashboard/Common/Graph/ZenVerBIB';
import ZenVerStackBar from '../../components/ManagerDashboard/Common/Graph/ZenVerStackBar';
import ZenVerCandleStick from '../../components/ManagerDashboard/Common/Graph/ZenVerCandleStick';
import Angela1C from '../../components/ManagerDashboard/Common/Angela/Angela1C';
import StablePrime from '../../components/Tables/StablePrime';
import Angela1R from '../../components/ManagerDashboard/Common/Angela/Angela1R';
import AngelaIcon1R from '../../components/ManagerDashboard/Common/Angela/AngelaIcon1R';
import AngelaIconMultiR1C from '../../components/ManagerDashboard/Common/Angela/AngelaIconMultiR1C';
import AngelaIconMultiR2C from '../../components/ManagerDashboard/Common/Angela/AngelaIconMultiR2C';
import Angela from '../../components/ManagerDashboard/Common/DataCard/Angela';
import RoutePage from '../../components/RoutePage';
import ImageViewer from '../../components/ImageViewer';
import ZenVerticalMultiLineSeriesChart from '../../components/ManagerDashboard/Common/Graph/ZenVerticalMultiLineSeriesChart';
import MultiTextDynamic from '../../components/MultiTextDynamic';
import ZenStackedClusterColHor from '../../components/ManagerDashboard/Common/Graph/ZenStackedClusterColHor';
import ZenStackedClusterColVer from '../../components/ManagerDashboard/Common/Graph/ZenStackedClusterColVer';

const ZenChartsInput = ({
    divId,
    enable,
    chartData,
    colSpan,
    typ,
    label,
    style,
    refreshData,
    src
}) => {
    return (
        <>
            {typ === "label" ? (
                <Col id={`dc-container-${divId}`} span={colSpan ? colSpan : 24}>
                    <p style={{ color: 'white', ...style }} title={label}>{label}</p>
                </Col>
            ) : (
                <></>
            )}
            {typ === "stable" ? (
                <Col id={`dc-container-${divId}`} span={colSpan ? colSpan : 24}>
                    <StablePrime url={chartData.api} data={chartData.params} />
                </Col>
            ) : (
                <></>
            )}
            {typ === "route" ? (
                <Col id={`dc-container-${divId}`}style={{ overflow: 'hidden' }} span={colSpan ? colSpan : 24}>
                    <RoutePage route={chartData.route} params={chartData.params} />

                </Col>
            ) : (
                <></>
            )}
            {typ === "multiTextDynamic" ? (
                <Col id={`dc-container-${divId}`} span={colSpan ? colSpan : 24}>
                    <div style={style}>
                        <MultiTextDynamic
                            data={chartData.config?.blockConfig[chartData.data.blockConfig]}
                            record={chartData.data.doc} />
                    </div>
                </Col>
            ) : (
                <></>
            )}
            {typ === "image" ? (
                <Col id={`dc-container-${divId}`} span={colSpan ? colSpan : 24}>
                    <ImageViewer imgStyle={style} urlData={chartData.params} api={chartData.api || '/imagecontrol'} />
                </Col>
            ) : (
                <></>
            )}
            {
                typ === 'ZenVerBarChart' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenVerBarChart
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenVerticalMultiLineSeriesChart' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenVerticalMultiLineSeriesChart
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'Angela1C' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <Angela1C
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'Angela1R' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <Angela1R
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'AngelaIcon1R' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <AngelaIcon1R
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'AngelaIconMultiR1C' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <AngelaIconMultiR1C
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'AngelaIconMultiR2C' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <AngelaIconMultiR2C
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'Angela' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <Angela
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenHorBarChart' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {enable && (
                                <ZenHorBarChart
                                    refreshData={refreshData}
                                    divId={divId}
                                    data={chartData.data}
                                    config={chartData.config}
                                    api={src === 'api' ? chartData.api : undefined}
                                    urlData={chartData.params}
                                />
                            )}

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenPieBar' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenPieBar
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenDonut' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenDonut
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenPareto' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenPareto
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenWaterfallChart' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenWaterfallChart
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenRadar' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenRadar
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenHorStackBar' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenHorStackBar
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'blankSpace' ?
                    <Col span={colSpan || 12} style={style}></Col> : <></>
            }
            {
                typ === 'ZenSpectrum' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenSpectrum
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenGauge' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenGauge
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenGaugeMultiColor' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenGaugeMultiColor
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenGanttChart' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenGanttChart
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenClusterColHor' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenClusterColHor
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenClusterColVer' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenClusterColVer
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenStackedClusterColHor' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenStackedClusterColHor
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenStackedClusterColVer' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenStackedClusterColVer
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenGoldenTunnel' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenGoldenTunnel
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />

                                )
                            }
                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenHorCandleStick' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenHorCandleStick
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenStackedNePo' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenStackedNePo
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenVerBIB' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenVerBIB
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenVerStackBar' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenVerStackBar
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
            {
                typ === 'ZenVerCandleStick' ?
                    <Col id={`dc-container-${divId}`} span={colSpan || 12} className='stable-charts'>
                        <div style={style}>
                            {
                                enable && (
                                    <ZenVerCandleStick
                                        refreshData={refreshData}
                                        divId={divId}
                                        data={chartData.data}
                                        config={chartData.config}
                                        api={src === 'api' ? chartData.api : undefined}
                                        urlData={chartData.params}
                                    />
                                )
                            }

                        </div>
                    </Col> : <></>
            }
        </>
    )
};

export default ZenChartsInput;